module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pXO5wG/tc-custom/9780547501673.jpg?1705766094750",
      "alt": "This image is the cover for the book Retrospective"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Retrospective\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An ageing film director must face his past in the acclaimed Israeli author’s prize-winning novel—“a compelling meditation on art, memory, love [and] guilt” ("), _c('i', [_vm._v("Independent")]), _vm._v(", UK).")]), _c('br'), _c('br'), _vm._v(" Yair Moses, an aging Israeli film director, has been invited to the Spanish pilgrimage city of Santiago de Compostela for a retrospective of his work. Accompanied by Ruth, his leading actress and longtime muse, Moses discovers a painting in their hotel room that triggers a distant memory from one of his early films: a scene that caused a rift with his brilliant but difficult screenwriter—who, as it happens, was once Ruth’s lover."), _c('br'), _c('br'), _vm._v(" Upon their return to Israel, Moses decides to travel to the south to look for his elusive former partner and propose a new collaboration. But the screenwriter demands a price that will have strange and lasting consequences. A searching and original novel by one of the world’s most esteemed writers, "), _c('i', [_vm._v("The Retrospective ")]), _vm._v("is a meditation on mortality and intimacy, on the limits of memory and the struggle of artistic creation."), _c('br'), _c('br'), _c('b', [_vm._v("Winner, 2012 Prix Médicis étranger")]), _c('br'), _c('b', [_vm._v("Winner, 2012 Prix du Meilleur Livre Étranger")]), _c('br'), _c('b', [_vm._v("A"), _c('i', [_vm._v(" New York Times Book Review")]), _vm._v(" Editor's Choice")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A. B. Yehoshua\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0